export const vehicleData = [
    {
        itemName: 'New Vehicle'
    },
    {
        itemName: 'Used Vehichle'
    },
    {
        itemName: 'Toyota Certified Used'
    },
    {
        itemName: 'Limetime Customer Commitment For New Vehicles'
    },
    {
        itemName: 'Lifetime Commitment For Used Vehicles'
    },
    {
        itemName: 'Sell Or Trade Your Vehichle'
    },
    {
        itemName: 'Vehichle Finder Service'
    },
    {
        itemName: 'Service'
    },
    {
        itemName: 'Part'
    },
    {
        itemName: 'Colition Center'
    },
    {
        itemName: 'Finance'
    },
    {
        itemName: 'Specials'
    },
    {
        itemName: 'Research'
    }
]

export const  callData = [
    {
        itemName: "Sales",
        number: "844.529.1532"
    },
    {
        itemName: "Service",
        number: "281.496.9730"
    },
    {
        itemName: "Ventas en Español",
        number: "832.321.8675"
    },
    {
        itemName: "Parts",
        number: "281.977.3030"
    },
    {
        itemName: "Collision",
        number: "281.588.2627"
    }
]